import { useEffect, useState } from "react";
import { Smartphone, X } from "lucide-react";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export default function InstallAppButton() {
  const [prompt, setPrompt] = useState(null);
  const [help, setHelp] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (installed) return null;

  const install = async () => {
    if (!prompt) return setHelp(true);
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setInstalled(true);
    setPrompt(null);
  };

  return (
    <>
      <button className="install-app-btn" onClick={install} data-testid="install-app-button">
        <Smartphone size={15}/><span><strong>Uygulamayı yükle</strong><small>Telefona / bilgisayara ekle</small></span>
      </button>
      {help && (
        <div className="modal-backdrop" onClick={() => setHelp(false)} data-testid="install-help">
          <div className="modal install-help" onClick={(e) => e.stopPropagation()}>
            <div className="modal-head"><div><div className="eyebrow">ANA EKRANA EKLE</div><h2>HazmatCore'u uygulama gibi kurun</h2></div>
              <button className="icon-button" onClick={() => setHelp(false)} data-testid="install-help-close"><X size={17}/></button></div>
            {isIOS() ? (
              <ol><li>Safari'de alttaki <b>Paylaş</b> (kare ve yukarı ok) simgesine dokunun.</li><li><b>Ana Ekrana Ekle</b>'yi seçin.</li><li>Sağ üstte <b>Ekle</b>'ye dokunun.</li></ol>
            ) : (
              <ol><li>Chrome'da sağ üstteki <b>⋮</b> (üç nokta) menüsünü açın.</li><li><b>Uygulamayı yükle</b> veya <b>Ana ekrana ekle</b>'yi seçin.</li><li><b>Yükle</b>'ye dokunun.</li></ol>
            )}
            <small className="legal-foot">Kurulduktan sonra HazmatCore ana ekranınızda simgesiyle tam ekran açılır.</small>
          </div>
        </div>
      )}
    </>
  );
}
